<template>
  <v-dialog v-model="dialog" @input="v => v || closeDialog()" max-width="893px">
    <v-card>
      <v-card-title v-if="messageTitle">
        <h2 class="md-title">{{ messageTitle | translate }}</h2>
      </v-card-title>
      <v-card-text class="px-4 pt-0">
        <p
          v-for="(item, index) in infoMessagesData"
          :key="item.id + index"
          class="my-3"
        >
          {{ `lng_info_${item.id}` | translate }}
          {{ `${item.argument}` }}
          {{ `${item.unit}` | translate }}
        </p>
      </v-card-text>
      <v-card-actions>
        <v-layout row wrap justify-end>
          <v-flex xs12 text-xs-right class="pr-2">
            <v-btn flat @click="closeDialog" class="def-btn">{{
              "lng_close" | translate
            }}</v-btn>
          </v-flex>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "HomeInfoMessagesModal",
  data() {
    return {
      dialog: false,
      infoMessagesData: []
    };
  },
  props: {
    messageText: {
      type: Array,
      default: () => []
    },
    openDialog: {
      type: Boolean,
      default: false
    },
    closeDialog: {
      type: Function,
      default: undefined
    },
    messageTitle: {
      type: String,
      default: ""
    }
  },
  watch: {
    openDialog: function(newVal) {
      this.dialog = newVal;
    },
    messageText: function(newVal) {
      this.getInfoMessages(newVal);
    }
  },
  methods: {
    getInfoMessages(msgArray) {
      let parsedArray = [];
      for (let i = 0, j = 0; i < msgArray.length / 3; i++, j += 3) {
        parsedArray[i] = {
          id: msgArray[j],
          argument: msgArray[j + 1],
          unit: msgArray[j + 2]
        };
      }
      this.infoMessagesData = parsedArray;
    }
  }
};
</script>
<style scoped>
.def-btn {
  color: rgb(84, 110, 122);
}
.md-title {
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 0.005em;
}
</style>
